module.exports = __webpack_public_path__ + "img/pic3.193679c7.png";